const distanceOptions = [
    { label: '25 miles', value: 25, mapZoom: 9 },
    { label: '50 miles', value: 50, mapZoom: 8 },
    { label: '100 miles', value: 100, mapZoom: 7 },
    { label: '250 miles', value: 250, mapZoom: 6 },
    { label: '500 miles', value: 500, mapZoom: 5 },
];

export { distanceOptions };
